'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _colorHelper = require('../../../common/colors/colorHelper');

require('./ColorBar.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
var ColorBar = function ColorBar(_ref) {
    var colorName = _ref.colorName;

    // Don't show the colour bar if the colour name is not provided
    if (!colorName) return null;

    // Otherwise convert the colour name to a hex value and render the bar
    var hexValue = (0, _colorHelper.getColorHexValue)(colorName);
    var style = {
        backgroundColor: hexValue
    };

    return _react2.default.createElement('div', { className: 'ColorBar', style: style });
};

// Styles
// Lib


ColorBar.propTypes = {
    colorName: _propTypes2.default.string
};

exports.default = (0, _recompose.onlyUpdateForPropTypes)(ColorBar);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/colors/ColorBar.js
// module id = 294
// module chunks = 0